import sal from 'sal.js'
import SmoothScroll from 'smooth-scroll'

window.addEventListener('load', () => {
	sal();

	new SmoothScroll('a[href*="#"]', {
		updateURL: false,
		offset: () => {
			return document.querySelector('.o-navigation--main').clientHeight + 32
		}
	})

	// const scrollTop = document.getElementById('projects').scrollTop
	// console.log(scrollTop)
	// if(window.location.hash) {
	// 	// const scrollTop = document.querySelector(window.location.hash).scrollTop


	// 	console.log(window.location.hash)
	// 	var scroll = new SmoothScroll();

	// 	scroll.animateScroll(scrollTop, {
	// 		offset: () => {
	// 			return document.querySelector('.o-navigation--main').clientHeight + 32
	// 		}
	// 	});
	// }
})



// WEBPACK FOOTER //
// ./js/modules/animations/scroll.js